import classnames from 'classnames'
import {useEffect, useMemo, useState} from 'react'
import {List, Map} from 'immutable'
import PropTypes from 'prop-types'

import ItemNavElement from './ItemNavElement'
import MobileItemNavElements from './MobileItemNavElements'

import {
  useOrganizationCobranding
} from '../../../../../shared_components/OrganizationCobrandingContext'

import {hasOrganizationCobranding} from '../../../../../lib/cobrandingTools'
import {topKitElementIdsWithResponse} from '../../../../../lib/plan_data/itemResponsesHelper'

import './itemNavElements.scss'


const ItemNavElements = props => {
  const [currentTabId, setCurrentTabId] = useState(props.currentTabId)

  const organizationCobranding = useOrganizationCobranding()

  useEffect(() => {
    if (props.currentTabId !== currentTabId)
      setCurrentTabId(props.currentTabId)
  }, [props.currentTabId])

  const navElements = useMemo(() => {
    if (props.isEditableItem) {
      return props.elements
    } else {
      const topElementsWithResponses = topKitElementIdsWithResponse(props.responseGroup)

      return props.elements.filter(element => topElementsWithResponses.includes(element.get('parent-element-id')))
    }
  }, [props.elements, props.responseGroup])

  return (
    <div className='item-nav-elements'>
      <nav
        className={classnames(
          'item-navigation',
          {'with-everplans-custom-colors': !hasOrganizationCobranding(
            organizationCobranding
          )}
        )}>
        <ul className='item-navigation-list'>
          {
            navElements.map(element => (
              <ItemNavElement
                element={element}
                key={element.get('id')}
                currentTabId={currentTabId}
                setCurrentTab={props.setCurrentTab}
              />
            ))
          }
        </ul>
      </nav>
      <MobileItemNavElements
        {...props}
        currentTabId={currentTabId}
        navElements={navElements}
      />
    </div>
  )
}

ItemNavElements.propTypes = {
  currentTabId: PropTypes.string,
  elements: PropTypes.instanceOf(List),
  isEditableItem: PropTypes.bool,
  responseGroup: PropTypes.instanceOf(Map),
  setCurrentTab: PropTypes.func,
  userConfig: PropTypes.instanceOf(Map)
}

export default ItemNavElements
